// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken } from "firebase/messaging"; // Import Messaging

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAYQDE5K-DLIZQ7xTzX3yXJu0ooXXm-r-c",
    authDomain: "somadome-916bb.firebaseapp.com",
    projectId: "somadome-916bb",
    storageBucket: "somadome-916bb.firebasestorage.app",
    messagingSenderId: "931650913960",
    appId: "1:931650913960:web:595d865e524cb72b97e49d",
    measurementId: "G-S8D8KT4Q7J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Messaging
// We need to check if messaging is supported (it works in browsers but might fail in some envs)
let messaging = null;

try {
    messaging = getMessaging(app);
} catch (error) {
    console.log("Firebase Messaging not supported in this environment");
}

export { app, analytics, messaging, getToken };
